import { useState, useEffect } from "react";
import { useLiferayLanguage } from "../hooks/useLiferayLanguage";

export const Filters = ({ aniosCategoryId, anios, onSearch }) => {

    const anioPlaceholder = useLiferayLanguage(
        "aena.label.select.anio", "Año"
    );
    const selectFechaText = useLiferayLanguage(
        "aena.select.fecha.publicacion", "Selecciona fecha de publicación"
    );
    const searchText = useLiferayLanguage(
        "aena.search", "Buscar"
    );
    const clearFiltersText = useLiferayLanguage(
        "aena.clear.selection", "Borrar selección"
    );

    const [year, setYear] = useState(null);
    const [instanceId, setInstanceId] = useState("");

    useEffect(() => {
        if (!aniosCategoryId) return;

        const informeElement = document.querySelector(`[anioscategoryid="${aniosCategoryId}"]`);

        if (!informeElement)  return;

        const parent = informeElement.closest(`[id*="informes_sostenibilidad_bus_custom_element_INSTANCE_"]`);

        if (!parent) return;

        const match = parent.id.match(/INSTANCE_([^_]+)$/);
        const foundInstanceId = match ? match[1] : "";

        setInstanceId(foundInstanceId);
    }, [aniosCategoryId]);

    const selectOption = (anio, event) => {
        event.preventDefault();
        event.stopPropagation();

        const trigger = document.querySelector(`.aena-dropdown__trigger_${instanceId}`);
        trigger.setAttribute("aria-expanded", "false");

        const panel = document.querySelector(`.aena-dropdown__panel_${instanceId}`);
        panel.classList.remove("is-expanded");

        const dropdownLabel = document.querySelector(`.aena-dropdown__label_${instanceId}`);
        dropdownLabel.innerText = anio.name;

        setYear(anio);
    };

    const onClear = () => {
        if(!year) return;

        const dropdownLabel = document.querySelector(`.aena-dropdown__label_${instanceId}`);
        dropdownLabel.innerText = anioPlaceholder;
        const dropdownPanel = document.querySelector(`.aena-dropdown__panel_${instanceId}`);
        const activeOption = dropdownPanel.querySelector(`li.is-active`);
        activeOption.classList.remove("is-active");
        activeOption.setAttribute("aria-selected", "false");
        const svg = activeOption.querySelector(`svg`);
        svg.remove();

        setYear(null);
        onSearch(null);
    };

    const handleSearchClick = () => {
        if (year) {
            onSearch(year);
        }
    };

    return (
        <div className="aena-form aena-form--drop-zone">
            <div>
                <div className="aena-field">
                    <label
                        className="paragraph-semibold-medium"
                        htmlFor="aena-dropdown-trigger"
                    >
                        {selectFechaText}
                    </label>

                    <div className="aena-dropdown aena-dropdown--w-full">
                        <button
                            aria-controls="aena-dropdown-panel"
                            aria-expanded="false"
                            aria-haspopup="listbox"
                            className={`aena-dropdown__trigger aena-dropdown__trigger_${instanceId} aena-input aena-input--large`}
                            id="aena-dropdown-trigger"
                            role="combobox"
                            tabIndex="0"
                            type="button"
                        >
                            <span className={`aena-dropdown__label aena-dropdown__label_${instanceId}`}>
                                {anioPlaceholder}
                            </span>
                            <svg
                                className="aena-sprite aena-dropdown__toggle"
                                aria-hidden="true"
                                focusable="false"
                            >
                                <use href="/o/aena-theme-spritemap/spritemap.svg#digital-flecha-abajo-1"></use>
                            </svg>
                        </button>

                        <ul
                            aria-labelledby="aena-dropdown-trigger"
                            className={`aena-dropdown__panel aena-dropdown__panel_${instanceId}`}
                            id="aena-dropdown-panel"
                            role="listbox"
                            tabIndex="-1"
                        >
                        {anios.map((anio) => (
                            <li
                                aria-selected="false"
                                className="aena-dropdown__option aena-dropdown__option--large"
                                key={anio.id}
                                onClick={(e) => selectOption(anio, e)}
                                role="option"
                            >
                                {anio.name}
                            </li>
                        ))}
                        </ul>
                    </div>
                </div>
            </div>

            <button
                className="aena-button aena-button--secondary aena-button--large aena-button--submit"
                disabled={!year}
                onClick={handleSearchClick}
            >
                {searchText}
            </button>

            <button
                className="aena-facet__clear aena-button aena-button--link aena-button--large aena-button--clear"
                onClick={onClear}
            >
                {clearFiltersText}
                <svg className="aena-sprite" aria-hidden="true" focusable="false">
                    <use href="/o/aena-theme-spritemap/spritemap.svg#digital-papelera"></use>
                </svg>
            </button>
        </div>
    );
};
